/* ----------------------------------------------------------------------------
js entry point
---------------------------------------------------------------------------- */
import SoundPlayer from './_elements/sound-player.js';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js', { scope: "./" });
}
